export const MAX_NOTES_CHARS_ALLOWED_FOR_WORKPLACE_QUIZ = 5000;
export const MIN_NOTES_CHARS_REQUIRED_FOR_WORKPLACE_QUIZ = 100;

export const NoteFieldIdentifiers = {
  PROFILE_DESC: "PROFILE_DESC",
  CHARTING_INSTRUCTIONS: "CHARTING_INSTRUCTIONS",
  CHECK_IN_INS_PARKING: "CHECK_IN_INS_PARKING",
  CHECK_IN_INS_ENTRANCE: "CHECK_IN_INS_ENTRANCE",
  CHECK_IN_INS_ORIENTATION: "CHECK_IN_INS_ORIENTATION",
  CHECK_IN_INS_EARLYCHECKIN: "CHECK_IN_INS_EARLYCHECKIN",
  CHECK_IN_INS_FIRSTSHIFT: "CHECK_IN_INS_FIRSTSHIFT",
  CHECK_IN_INS_TIMECARD: "CHECK_IN_INS_TIMECARD",
  CHECK_IN_INS_DRESS: "CHECK_IN_INS_DRESS",
  CHECK_IN_INS_OTHER: "CHECK_IN_INS_OTHER",
  MANDATORY_BREAK_POLICY: "MANDATORY_BREAK_POLICY",
  REST_BREAK_POLICY: "REST_BREAK_POLICY",
  LATE_CLOCK_OUT_POLICY: "LATE_CLOCK_OUT_POLICY",
} as const;

export const IGNORED_NOTE_IDENTIFIERS_FOR_QUIZ = [
  NoteFieldIdentifiers.MANDATORY_BREAK_POLICY,
  NoteFieldIdentifiers.REST_BREAK_POLICY,
  NoteFieldIdentifiers.LATE_CLOCK_OUT_POLICY,
] as const;

export const DEFAULT_MANDATORY_BREAK_POLICY_NOTE =
  "The only circumstances under which working through a break is allowed at this workplace is if workplace staff instructs you to work through the break, or if no workplace staff was present during the shift to instruct you to work through but the workload made it unavoidable to work through the break.";

export const DEFAULT_REST_BREAK_POLICY_NOTE =
  "Professionals working at this workplace are given the opportunity to take a paid 10 minute rest period for every four hours worked.";
